import React from 'react'

const Footer = () => {
    return (
        <div className="footer">
            <h3 className="footer-title">By Pedro Castellanos Alonso</h3>
            <div className="social-links">
                <a href="https://www.facebook.com/pedro.castellanosalonso" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a>
                <a href="https://instagram.com/pedrocastellanos2003" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
                <a href="https://github.com/pedrocastellanos" target="_blank" rel="noopener noreferrer"><i className="fab fa-github"></i></a>
            </div>
        </div>
    )
}

export default Footer
